import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { installStaleChunkRecovery } from "@/lib/stale-chunk-recovery";
import { captureBatch1ActivationToken } from "@/lib/batch1ActivationToken";
import "./index.css";

// Load the app only after removing an activation token from the URL. Static
// App imports would initialize Auth/analytics modules before this line runs.
captureBatch1ActivationToken();

// Antes del render a proposito: los import() lazy de App.tsx e Index.tsx se
// resuelven despues de montar, y el listener tiene que estar puesto antes de que
// cualquiera de ellos pueda fallar.
installStaleChunkRecovery();

void import("./App.tsx").then(({ default: App }) => {
  createRoot(document.getElementById("root")!).render(
    <HelmetProvider>
      <App />
    </HelmetProvider>
  );
});
